import { ReferenceTaskShape, TaskShape, TaskStatus } from "@eave/shared/types/api";
import APIClient from "web_modules/APIClient";

// TODO: When all handlers are finished, move all API calls here

export function getTasksForApplication(appID: number) {
  return APIClient.get(`/uw/loan_applications/${appID}/tasks`);
}

export function getOperators() {
  return APIClient.get("/uw/operators");
}

export function batchUpdateTasksForApplication(
  appID: number,
  updated_tasks: TaskShape[],
  updated_status: TaskStatus,
) {
  return APIClient.put(`/uw/loan_applications/${appID}/batch_update_tasks`, {
    updated_tasks: updated_tasks.map(t => ({ ...t, status: updated_status })),
  });
}

export function updateTaskForApplication(appID: number, taskID: number, data: any) {
  return APIClient.put(`/uw/loan_applications/${appID}/tasks/${taskID}`, data);
}

export function createTask(appID, data) {
  return APIClient.post(`/uw/loan_applications/${appID}/tasks`, data);
}

/* Reference Task Routes */

export function getTaskOptions() {
  return APIClient.get(`/uw/tasks/task_options`);
}
export async function getReferenceTasks(): Promise<ReferenceTaskShape[]> {
  const { tasks } = (await APIClient.get(`/uw/tasks/reference_tasks`)) as {
    tasks: ReferenceTaskShape[];
  };

  return tasks;
}

export async function updateReferenceTask(id: number, payload): Promise<any> {
  return APIClient.put(`/uw/tasks/reference_tasks/${id}`, payload);
}

export async function createReferenceTask(payload) {
  return APIClient.post(`/uw/tasks/reference_tasks`, payload);
}

export async function deleteReferenceTask(id: number) {
  return APIClient.deleteRequest(`/uw/tasks/reference_tasks/${id}`);
}
